import { useTranslation } from 'react-i18next'
import { Clock } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Alert, AlertDescription } from '@/components/ui/alert'

export function VerificationPendingPage() {
  const { t } = useTranslation()
  return (
    <Card className="w-full max-w-lg">
      <CardContent className="space-y-6 pt-8">
        <div className="flex flex-col items-center gap-3 text-center">
          <Clock
            className="size-14 shrink-0 text-amber-600 dark:text-amber-500"
            strokeWidth={1.75}
            aria-hidden
          />
        </div>
        <Alert variant="default">
          <AlertDescription className="whitespace-pre-line text-center">
            {t('onboarding:success.description')}
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  )
}
